<template>
  <div class="detail-channel">
    <el-form
      ref="formDataRef" :model="queryForm" label-position="top"
      :disabled="operateType === 1"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$t('operationCenter.channel')"
            prop="channelValue"
            :rules="{
              required: true,
              message: $t('basicData.CannotBeEmpty'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="queryForm.channelValue"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%;"
              clearable
              filterable
              :disabled="operateType === 2"
            >
              <el-option
                v-for="item in channelOption"
                :key="item.id"
                :label="item.dictName"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$t('collectionCenter.stateZT')"
            prop="status"
            :rules="{
              required: true,
              message: $t('basicData.CannotBeEmpty'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="queryForm.status"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%;"
              clearable
              filterable
            >
              <el-option key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
              <el-option key="2" :label="$t('GlobalSetObj.disable')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>{{ $t('customerManagements.ExpressSmallParcel') }}</div>
          <div style="display: flex">
            <div style="width: 200px;">
              <el-form-item
                prop="smallCalculationMethod"
                :rules="{
                  required: (!((queryForm.largeCalculationMethod === 0 || queryForm.largeCalculationMethod === 1) && (queryForm.largeCalculateBase || queryForm.largeCalculateBase === 0)) || (queryForm.smallCalculateBase || queryForm.smallCalculateBase === 0)),
                  message: $t('basicData.CannotBeEmpty'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="queryForm.smallCalculationMethod"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option key="1" label="*" :value="0" />
                  <el-option key="2" label="/" :value="1" />
                </el-select>
              </el-form-item>
            </div>
            <div style="flex: 1">
              <el-form-item
                prop="smallCalculateBase"
                :rules="[
                  {
                    required: (!((queryForm.largeCalculationMethod === 0 || queryForm.largeCalculationMethod === 1) && (queryForm.largeCalculateBase || queryForm.largeCalculateBase === 0)) || (queryForm.smallCalculationMethod === 0 || queryForm.smallCalculationMethod === 1)),
                    message: $t('basicData.CannotBeEmpty'),
                    trigger: ['blur', 'change']
                  },
                  {
                    pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                    message: $t('compensationManagement.inputdayuzuoduo2'),
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input v-model="queryForm.smallCalculateBase" :placeholder="$t('collectionCenter.pleaseInput')" />
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>{{ $t('customerManagements.ExpressLargeParcel') }}</div>
          <div style="display: flex">
            <div style="width: 200px;">
              <el-form-item
                prop="largeCalculationMethod"
                :rules="{
                  required: (!((queryForm.smallCalculationMethod === 0 || queryForm.smallCalculationMethod === 1) && (queryForm.smallCalculateBase || queryForm.smallCalculateBase === 0)) || (queryForm.largeCalculateBase || queryForm.largeCalculateBase === 0)),
                  message: $t('basicData.CannotBeEmpty'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="queryForm.largeCalculationMethod"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option key="1" label="*" :value="0" />
                  <el-option key="2" label="/" :value="1" />
                </el-select>
              </el-form-item>
            </div>
            <div style="flex: 1">
              <el-form-item
                prop="largeCalculateBase"
                :rules="[
                  {
                    required: (!((queryForm.smallCalculationMethod === 0 || queryForm.smallCalculationMethod === 1) && (queryForm.smallCalculateBase || queryForm.smallCalculateBase === 0)) || (queryForm.largeCalculationMethod === 0 || queryForm.largeCalculationMethod === 1)),
                    message: $t('basicData.CannotBeEmpty'),
                    trigger: ['blur', 'change']
                  },
                  {
                    pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                    message: $t('compensationManagement.inputdayuzuoduo2'),
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input v-model="queryForm.largeCalculateBase" :placeholder="$t('collectionCenter.pleaseInput')" />
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="24" style="margin-top: 20px;">
          <div style="display: flex;margin-bottom: 20px;align-items: center">
            <div style="width: 50px;text-align: center">
              <i class="el-icon-warning-outline" style="font-size: 24px;" />
            </div>
            <div style="flex: 1">
              <div>
                {{ $t('ChannelManage.WhenTheStatusIsEnabled') }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div style="display: flex;margin-bottom: 20px;align-items: center">
            <div style="width: 50px" />
            <div style="flex: 1">
              <div>
                <!--配置"/",用(长*宽*高)/计算基数-->
                {{ $t('ChannelManage.ConfigureCalculateTheBase') }}
              </div>
              <div>
                <!--配置"*",用(长*宽*高)/1000000*计算基数-->
                {{ $t('ChannelManage.ConfigurationCalculatedUsingBase') }}
              </div>
              <div>
                <!--长,宽,高单位都是cm-->
                {{ $t('ChannelManage.TheUnitsAllCentimeters') }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

import { channelVolumeConfigAdd, channelVolumeConfigUpdate } from '@/api/finance/basicData';

export default {
  name: 'AddChannel',
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {
          id: '',
          channelValue: '',
          status: 1,
          smallCalculationMethod: 0,
          smallCalculateBase: '',
          largeCalculationMethod: 0,
          largeCalculateBase: ''
        };
      }
    },
    channelOption: {
      type: Array,
      default: () => []
    },
    operateType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      queryForm: {
        id: '',
        channelValue: '',
        status: 1,
        smallCalculationMethod: 0,
        smallCalculateBase: '',
        largeCalculationMethod: 0,
        largeCalculateBase: ''
      }
    };
  },
  created() {
    if (this.operateType !== 0) {
      this.queryForm = JSON.parse(JSON.stringify(this.detailData));
    }
  },
  methods: {
    // 确定新增渠道
    confirmAddChannel() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          if (this.operateType === 0) {
            channelVolumeConfigAdd(this.queryForm).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$emit('tableUpdate', true);
              }
            });
          }
          if (this.operateType === 2) {
            channelVolumeConfigUpdate(this.queryForm).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$emit('tableUpdate', true);
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style>
.detail-channel .el-input.is-disabled .el-input__inner,
.detail-channel .el-textarea.is-disabled .el-textarea__inner {
  color: #727c8a !important;
}
</style>
